export default __webpack_public_path__ + "static/white-nr-black-desserto-da9ddb4cd812b2b31dfb6dc2ef0750ec.png";